(() => {
 'use strict';
 const el=document.querySelector('[data-br-band-config]');
 if(!el)return;
 const config=JSON.parse(el.textContent);
 const pack=config.variants.find(v=>v.available&&v.price===0);
 const setHandle='beam-rivals-neon-battle-set';
 const giftTitle='BEAM RIVALS Glow Bands — 4-Pack';
 const eligible=item=>item.handle===setHandle&&[2,4,8].includes(Number(item.variant_title?.split(' ')[0]));
 function requirePack(){
  if(!pack)throw new Error('Your free gift could not be confirmed. Please reopen your bag before checkout.');
 }
 function propertiesFor(item){
  const properties={...item.properties,_br_bundle:item.properties?._br_bundle||crypto.randomUUID(),_br_gift_version:'4pack','Included gift':giftTitle};
  delete properties._br_band_selection;
  delete properties._br_band_total_selection;
  return properties;
 }
 function prepare(form,body){
  if(!form.matches('[data-br-add]')||!form.querySelector('[data-band-picker]'))return body;
  requirePack();
  body.set('properties[_br_bundle]',crypto.randomUUID());
  body.set('properties[_br_gift_version]','4pack');
  body.set('properties[Included gift]',giftTitle);
  return body;
 }
 // One physical four-pack per purchased set; never derive gifts from player count.
 async function sync(cart,request,cartURL){
  if(cart.items.some(eligible))requirePack();
  const legacy=cart.items.find(i=>eligible(i)&&(!i.properties?._br_bundle||i.properties?._br_gift_version!=='4pack'||i.properties?.['Included gift']!==giftTitle||i.properties?._br_band_selection||i.properties?._br_band_total_selection));
  if(legacy){
   // Property changes re-key Shopify lines. Re-read the returned cart before linking gifts.
   const updated=await request(`${cartURL}/change.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:legacy.key,quantity:legacy.quantity,properties:propertiesFor(legacy)})});
   return sync(updated,request,cartURL);
  }
  const parents=cart.items.filter(eligible),updates={},adds=[];
  for(const parent of parents){
   let found=false;
   for(const child of cart.items.filter(i=>i.properties?._br_band_parent===parent.properties._br_bundle)){
    const matching=String(child.variant_id)===String(pack.id)&&!found;
    const quantity=matching?parent.quantity:0;
    if(matching)found=true;
    if(child.quantity!==quantity)updates[child.key]=quantity;
   }
   if(!found)adds.push({id:Number(pack.id),quantity:parent.quantity,parent_line_key:parent.key,properties:{_br_band_parent:parent.properties._br_bundle,'Included with':'BEAM RIVALS battle set'}});
  }
  const groups=new Set(parents.map(p=>p.properties._br_bundle));
  for(const item of cart.items)if(item.properties?._br_band_parent&&!groups.has(item.properties._br_band_parent))updates[item.key]=0;
  if(Object.keys(updates).length)cart=await request(`${cartURL}/update.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
  if(adds.length){
   await request(`${cartURL}/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:adds})});
   cart=await request(`${cartURL}.js`,{cache:'no-store'});
  }
  for(const parent of parents){
   const children=cart.items.filter(i=>i.properties?._br_band_parent===parent.properties._br_bundle);
   if(children.some(i=>i.final_price!==0))throw new Error('Your gift price could not be confirmed. Please review your bag.');
   if(children.length!==1||String(children[0].variant_id)!==String(pack.id)||children[0].quantity!==parent.quantity)throw new Error('Your free gift is still updating. Reopen your bag before checkout.');
  }
  return cart;
 }
 window.BeamBands={prepare,sync};
})();
